module.exports = "/virtual-football-league/img/amblems/right/logos/Roma.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Roma.png
// module id = 2226
// module chunks = 4